import { render, staticRenderFns } from "./WhatIfs.vue?vue&type=template&id=1f86025f&scoped=true&"
import script from "./WhatIfs.vue?vue&type=script&lang=js&"
export * from "./WhatIfs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f86025f",
  null
  
)

export default component.exports